import { ActionTree, GetterTree, MutationTree } from "vuex";

export enum ErrorType {
  NETWORK_ERROR,
  GRAPHQL_ERROR,
  UNDER_MAINTENANCE,
  WEB3_ERROR,
}
export interface IError {
  message: string;
  type: ErrorType;
}

export class State {
  public stack: IError[] = [];
}

const getters: GetterTree<State, any> = {
  count(state: State): number {
    return state.stack.length;
  },
};

const mutations: MutationTree<State> = {
  push(state: State, val: IError) {
    state.stack.push(val);
  },
  clear(state: State) {
    state.stack = [];
  },
};
const actions: ActionTree<State, any> = {};

export const error = {
  namespaced: true,
  state: new State(),
  getters,
  mutations,
  actions,
};
